__turbopack_context__.v({
  "bw-tooltip": "Tooltip-module__QXJ1FG__bw-tooltip",
  "content-wrapper": "Tooltip-module__QXJ1FG__content-wrapper",
  "dark-theme": "Tooltip-module__QXJ1FG__dark-theme",
});
